import React from 'react';
import { SearchIcon, MailIcon, DatabaseIcon, SendIcon } from 'lucide-react';
export function DataDirectoryValueProps() {
  return <section className="py-24 bg-white" data-id="element-722">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-723">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-724">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-725">
            Why teams choose our{' '}
            <span className="text-blue-600" data-id="element-726">local business database</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-727">
            The most reliable source for local business listings and verified
            contact data.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-728">
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-729">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6" data-id="element-730">
              <SearchIcon className="w-6 h-6" data-id="element-731" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-732">
              Local business owner finder
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-733">
              Find verified owners and decision-makers at local small
              businesses. Our local business owner finder gives you direct
              access to the people who make purchasing decisions.
            </p>
          </div>

          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-734">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6" data-id="element-735">
              <MailIcon className="w-6 h-6" data-id="element-736" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-737">
              Verified business owner emails
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-738">
              Every business owner email in our database is verified in
              real-time. Stop bouncing — reach local business owners with
              confidence.
            </p>
          </div>

          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-739">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6" data-id="element-740">
              <DatabaseIcon className="w-6 h-6" data-id="element-741" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-742">
              Comprehensive local business listings
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-743">
              Browse 300+ categories of local business listings with 50+ data
              points per business. The most complete local business database
              available.
            </p>
          </div>

          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-100" data-id="element-744">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-blue-600 mb-6" data-id="element-745">
              <SendIcon className="w-6 h-6" data-id="element-746" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-747">
              Built-in email sequencing
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-748">
              Launch personalized email campaigns directly to local businesses
              from our platform. No CSV exports needed.
            </p>
          </div>
        </div>
      </div>
    </section>;
}